import { Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import "./index.scss";

interface IProps {
  placeholder?: string;
  value?: string;
  rows?: number;
  name?: string;
  disabled?: boolean;
  maxLength?: number;
  style?: string;
  setValue?: Dispatch<SetStateAction<string>>;
}

export const TextArea = ({
  placeholder,
  value,
  rows,
  name,
  disabled,
  maxLength,
  style,
  setValue,
}: IProps) => {
  return (
    <textarea
      className={classNames("text-area", style && `${style}`)}
      placeholder={placeholder}
      value={value}
      rows={rows}
      name={name}
      disabled={disabled}
      maxLength={maxLength}
      onChange={(event: any) => setValue && setValue(event.target.value)}
    />
  );
};
